// extracted by mini-css-extract-plugin
export var askAiIcon = "_nj-j";
export var category = "_nj-9";
export var categoryHeader = "_nj-e";
export var container = "_nj-0";
export var group = "_nj-a";
export var groupItems = "_nj-f";
export var groupSeparator = "_nj-k";
export var loading = "_nj-1";
export var noResults = "_nj-3";
export var placeholder = "_nj-2";
export var resultContent = "_nj-5";
export var resultIcon = "_nj-c";
export var resultItem = "_nj-g";
export var resultMeta = "_nj-8";
export var resultSubtitle = "_nj-7";
export var resultSuffix = "_nj-i";
export var resultTitle = "_nj-6";
export var resultsList = "_nj-4";
export var searchGroup = "_nj-d";
export var selected = "_nj-h";
export var subgroup = "_nj-b";